import ClippedText from "@atoms/clipped-text";

function TransactionHash({ hash }: { hash: string }) {
  return <ClippedText text={`#${hash}`} allowCopy />;
}

export default TransactionHash;
